export function getNodeIndex(node) {
  const parentNode = node.parentNode
  if (!parentNode) {
    return -1
  }

  const childNodes = parentNode.children || parentNode.childNodes

  for (let i = 0; i < childNodes.length; i++) {
    if (childNodes[i] === node) {
      return i
    }
  }

  return -1
}
